const duplicateArrayItems = <T>(initialArray: T[], minTargetCount: number) => {
  if (!initialArray?.length) return [];

  const multiplier = Math.ceil(minTargetCount / initialArray.length);
  const newArray = new Array<T[]>(multiplier).fill(initialArray).flat();

  return newArray;
};

export default duplicateArrayItems;
